/* eslint-disable class-methods-use-this */
import jwt_decode from "jwt-decode"
// TODO archi a revoir
// import FactApi from "../API/fact"
import i18n from "i18next"
import ModuleApi from "../API/module"
import { SearchLinks } from "../models/search"
import { Module } from "../models/module"
import { Service } from "./Service"
import StoreService from "./store"

class ModuleService extends Service {
    private static instance: ModuleService

    constructor() {
        super()
        // set le nom du service
        this.name = "ModuleService"
        // ajoute toute les methodes du service au tableau de mapping
        // this.serviceMap = []
        this.serviceMap.push({ key: "getModule", fct: this.getModule })
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): ModuleService {
        if (!this.instance) {
            this.instance = new ModuleService()
        }
        return this.instance
    }

    /**
     * getModule check la session courante
     *  ou lance API REST  de getModule afin de pouvoir récupérer
     * les modules de user connecté
     */
    public async getModule(): Promise<Array<Module>> {
        let modules = []
        const token = await StoreService.getInstance().persistant.get("token")
        if (token) {
            const decoded = jwt_decode(token) as any
            if (
                StoreService.getInstance().local.getSession(
                    `mod_${decoded.userId}`
                )
            )
                return StoreService.getInstance().local.getSession(
                    `mod_${decoded.userId}`
                )

            const modulesRes = await ModuleApi.getAllModulesByUser(
                decoded.userId
            )

            if (modulesRes) modules = modulesRes

            StoreService.getInstance().local.setSession(
                `mod_${decoded.userId}`,
                modules
            )
            return modules
        }
        throw Error("No token found")
    }

    /**
     * getUserModules Récupère les modules de l'user passé en paramètre
     */
    public async getUserModules(userId: string): Promise<Array<Module>> {
        return ModuleApi.getAllModulesByUser(userId)
    }

    /**
     * getAllModules Renvoie une liste de tous les modules disponibles
     * sous forme allégèe avec les permissions liées
     */
    public async getAllModules(): Promise<
        Array<{
            _id: string
            displayName: string
            refs: Array<{ permissionLevel: number; id: string }>
        }>
    > {
        const modules = await ModuleApi.getAllModules()
        return modules
    }

    /**
     * getFilters retourne tous les filtres de recherche
     * disponibles
     */
    public getFilters(
        searchLinks: Array<SearchLinks>
    ): Array<{ name: string; value: string }> {
        let filters = [{ name: i18n.t("all"), value: "all" }]
        if (searchLinks.length)
            for (let index = 0; index < searchLinks.length; index += 1) {
                filters = filters.concat(searchLinks[index].indexes)
            }

        return filters
    }

    /**
     * Met à jour les modules dont l'user à droit
     * @param userId user id
     * @param moduleIds liste des ids des id des modules
     */
    public async updateModulesByUser(
        userId: string,
        modules: Array<string>
    ): Promise<boolean> {
        if (modules && userId) {
            const response = await ModuleApi.updateModulesByUser(
                userId,
                modules
            )

            if (response.status === 200) {
                return true
            }
        }
        return false
    }

    /**
     * getAdminModules Renvoie une liste de tous les admin modules disponibles
     */
    public async getAdminModules(): Promise<any> {
        const modules = await ModuleApi.getAdminModules()

        return modules
    }
}

export default ModuleService
